// src/setupFetch401.js
(function () {
    if (typeof window === "undefined" || !window.fetch) return;

    const originalFetch = window.fetch;

    window.fetch = async function (input, init = {}) {
        const opts = { ...init };
        const headers = new Headers(opts.headers || {});
        const token = localStorage.getItem("token");

        // 1) Inyectar Authorization si no lo pasaste ya
        if (token && !headers.has("Authorization")) {
            headers.set("Authorization", `Bearer ${token}`);
        }

        const body = opts.body;
        const isFormData = body instanceof FormData;
        const isBlob = body instanceof Blob; // File hereda de Blob
        const isURLSearchParams = body instanceof URLSearchParams;

        // 2) Gestionar Content-Type correctamente según el tipo de body
        if (!headers.has("Content-Type")) {
            if (isFormData || isBlob) {
                // NO establecer Content-Type: el navegador lo hace (con boundary en multipart)
                // Deja opts.body tal cual
            } else if (isURLSearchParams) {
                headers.set("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
                // body ya es serializable por el propio fetch
            } else if (
                body &&
                typeof body === "object" &&
                !(body instanceof ArrayBuffer) &&
                !(body instanceof DataView) &&
                typeof body.getReader !== "function" // no streams
            ) {
                headers.set("Content-Type", "application/json");
                opts.body = JSON.stringify(body);
            }
            // Si body es string o vacío, no tocamos nada
        } else {
            // Si alguien puso application/json pero el body es FormData/Blob, borramos el header
            const ct = headers.get("Content-Type") || "";
            if ((isFormData || isBlob) && ct.includes("application/json")) {
                headers.delete("Content-Type");
            }
        }

        opts.headers = headers;

        const res = await originalFetch(input, opts);

        // 3) Manejo de 401 (evita bucle de redirección)
        if (res.status === 401) {
            try { localStorage.removeItem("token"); } catch { }
            if (!window.location.pathname.startsWith("/login")) {
                window.location.href = "/login?reason=session_expired";
            }
        }

        return res;
    };
})();
